import { 
    FETCH_CITY,
    FETCH_CITY_SUCCESS,
    FETCH_CITY_FAILED,
    EDIT_CITY
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    cars:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_CITY:
        return {
          ...state,
          loading:true
        };
      case FETCH_CITY_SUCCESS:
        return {
          ...state,
          cars:action.payload,
          loading:false
        };
      case FETCH_CITY_FAILED:
        return {
          ...state,
          cars:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case EDIT_CITY:
        return state;
      default:
        return state;
    }
  };